import {
  TComponentValue,
} from '@/types/openapi-type';

const details: Record<TComponentValue<'AuditEnvelopStabilizationCombinationType'>, string> = {
  0: 'Dauer wird an die ignorierten Rezeptschritte angehangen.',
  1: 'Entweder Dauer oder Rezeptschritte, was immer früher ist.',
  2: 'Entweder Dauer oder Rezeptschritte, was immer später ist.',
};

export default {
  details,
};
